(function () {
  'use strict';

  function closeItem(item) {
    var trigger = item.querySelector('.cs-accordion__trigger');
    var panel = item.querySelector('.cs-accordion__panel');
    if (!trigger || !panel) return;

    trigger.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    panel.style.height = '0';
  }

  function openItem(item) {
    var trigger = item.querySelector('.cs-accordion__trigger');
    var panel = item.querySelector('.cs-accordion__panel');
    var inner = item.querySelector('.cs-accordion__panel-inner');
    if (!trigger || !panel || !inner) return;

    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    panel.style.height = inner.offsetHeight + 'px';
  }

  function initGroup(group) {
    var items = group.querySelectorAll('.cs-accordion__item');

    items.forEach(function (item) {
      var trigger = item.querySelector('.cs-accordion__trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        items.forEach(closeItem);

        if (!isOpen) {
          openItem(item);
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-cs-accordion]').forEach(initGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
